'use strict';

angular.module('AcaApp').factory('MsgBetweenCtrlService', function(){
  return {
    data: {},
    clearData: function(){
      this.data = {};
    }
  };
});